import { MultiColumnRichTextEntry, RichTextEntry } from "../schema/blocks";
import { ContentfulEntry } from "../schema/sys";
import { documentToString } from "./document-to-string";
import { isContentType } from "./is-content-type";

export function entriesToString(entries?: Array<ContentfulEntry>) {
  if (!entries || !Array.isArray(entries)) return "";

  return entries.reduce((prev, entry) => {
    if (isContentType<RichTextEntry>("richText", entry)) {
      return prev + documentToString(entry.fields.text);
    }

    if (isContentType<MultiColumnRichTextEntry>("multiColumnRichText", entry)) {
      return prev + documentToString(entry.fields.content);
    }

    return prev;
  }, "");
}
